import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Forwarder, ForwarderCreate, ForwarderUpdate } from '../../../shared/interfaces/forwarder.interfaces';

export const ForwarderActions = createActionGroup({
  source: 'Forwarder',
  events: {
    'Load Forwarders': emptyProps(),
    'Load Forwarders Success': props<{ data: Forwarder[] }>(),

    'Create Forwarder': props<{ payload: ForwarderCreate }>(),
    'Create Forwarder Success': props<{ data: any }>(),

    'Load Forwarder Details': props<{ id: number }>(),
    'Load Forwarder Details Success': props<{ data: Forwarder }>(),

    'Delete Forwarder': props<{ id: number }>(),
    'Delete Forwarder Success': props<{ data: any }>(),

    'Update Forwarder': props<{ payload: ForwarderUpdate }>(),
    'Update Forwarder Success': props<{ data: Forwarder }>(),

    'Unset Forwarder Store': emptyProps(),
  }
});
